import { AvailableLabel } from "@/types/v2";

/**
 * Finds the Tekmetric catalog entry for each candidate bidirectional label
 * that matches the card's current status. Mirrors the two-tier match
 * `resolveLabelSyncEvent.ts` (integrations) does inline for its single-label
 * case: try the numeric status id first, then fall back to the status name.
 * Labels with no matching entry are dropped.
 * @param {string[]} labels - Candidate label names (a container's normalized `bidirectionalLabel`).
 * @param {AvailableLabel[] | undefined} labelCatalog - The shop's Tekmetric label catalog.
 * @param {{ statusEnum?: string; status?: string }} card - The card's current status fields.
 * @returns {{ label: string; catalogEntry: AvailableLabel }[]} Matching candidates, in the input labels' order.
 */
export function matchBidirectionalLabels(
  labels: string[],
  labelCatalog: AvailableLabel[] | undefined,
  card: { statusEnum?: string; status?: string }
): { label: string; catalogEntry: AvailableLabel }[] {
  const catalog = labelCatalog ?? [];

  return labels.reduce<{ label: string; catalogEntry: AvailableLabel }[]>(
    (matches, label) => {
      const catalogEntry =
        catalog.find(
          (entry) =>
            entry.name === label &&
            entry.repairOrderStatus != null &&
            card.statusEnum != null &&
            `${entry.repairOrderStatus.id}` === card.statusEnum
        ) ??
        catalog.find(
          (entry) =>
            entry.name === label &&
            entry.repairOrderStatus != null &&
            card.status != null &&
            entry.repairOrderStatus.name === card.status
        );

      if (catalogEntry) {
        matches.push({ label, catalogEntry });
      }

      return matches;
    },
    []
  );
}
